const materialNumberFormatter = {
    // material_number kadang di-pad dengan banyak angka 0 di kiri (mis. SAP internal number).
    // Kalau angka 0 berjejer di kiri lebih dari 6 digit, potong sampai digit non-nol pertama.
    formatMaterialNumber(materialNumber) {
        if (!materialNumber) return materialNumber;
        const value = String(materialNumber);
        const leadingZeros = (value.match(/^0+/) || [''])[0].length;
        if (leadingZeros <= 6) return value;
        return value.slice(leadingZeros) || '0';
    }
}

export default materialNumberFormatter
